export { slotsLangEnUs } from './en-US';
export { slotsLangEsMx } from './es-MX';
export { slotsLangPtBr } from './pt-BR';
export { slotsIntlIds } from './slots.ids';
